import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-5 hero-grid">
      <form
        onSubmit={submit}
        className="w-full max-w-[420px] bg-[var(--surface)] border border-[var(--border)] rounded-2xl p-10"
        data-testid="admin-login-form"
      >
        <img
          src="/naami-wordmark.png"
          alt="Naami Kitchens United"
          className="h-10 w-auto mb-2"
          style={{ filter: "invert(1) brightness(1.05)" }}
        />
        <p className="eyebrow mb-1">// Admin</p>
        <h1 className="font-display text-[44px] leading-none mt-2 mb-8">
          Sign In
        </h1>

        <label className="block font-mono text-[10px] uppercase tracking-[0.18em] text-muted mb-1.5">
          Email
        </label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="input-nk mb-4"
          data-testid="admin-email-input"
          placeholder="admin@naamikitchens.com"
        />

        <label className="block font-mono text-[10px] uppercase tracking-[0.18em] text-muted mb-1.5">
          Password
        </label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="input-nk mb-2"
          data-testid="admin-password-input"
          placeholder="••••••••"
        />

        {error && (
          <p className="text-[var(--error)] text-[13px] mt-3" data-testid="admin-login-error">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={loading}
          className="btn-primary w-full justify-center mt-6"
          data-testid="admin-login-submit"
        >
          {loading ? "Signing in…" : "Sign In"}
        </button>

        <a
          href="/"
          className="block text-center mt-6 font-mono text-[11px] uppercase tracking-[0.18em] text-muted hover:text-gold transition-colors"
        >
          ← Back to site
        </a>
      </form>
    </main>
  );
}
